module.exports = __webpack_public_path__ + "img/6-2.ae981d59.jpg";